module.exports = __webpack_public_path__ + "img/pc_equity.eaa5f27f.png";